import { render } from "./ComponentType.vue?vue&type=template&id=260e30e5"
import script from "./ComponentType.vue?vue&type=script&lang=js"
export * from "./ComponentType.vue?vue&type=script&lang=js"

import "./ComponentType.vue?vue&type=style&index=0&id=260e30e5&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__